'use client';
import styles from './tips.module.scss';

export default function SaleTips(labels: string) {
  return labels ? (
    <div className={styles.tagGroup}>
      <span className={styles.tips2}>{labels}</span>
      <span className={styles.placeHolder}></span>
    </div>
  ) : (
    <div className={styles.tagGroup}>
      <span className={styles.placeHolder}></span>
    </div>
  );
}
